import { getMainCarrier } from '@sentry/hub';
import { IdleTransaction } from './idletransaction';
import { Transaction } from './transaction';
/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
    var scope = this.getScope();
    if (scope) {
        var span = scope.getSpan();
        if (span) {
            return {
                'sentry-trace': span.toTraceparent(),
            };
        }
    }
    return {};
}
/**
 * Use RNG to generate sampling decision, which all child spans inherit.
 */
function sample(hub, transaction) {
    var client = hub.getClient();
    if (transaction.sampled === undefined) {
        var sampleRate = (client && client.getOptions().tracesSampleRate) || 0;
        // if true = we want to have the transaction
        // if false = we don't want to have it
        // Math.random (inclusive of 0, but not 1)
        transaction.sampled = Math.random() < sampleRate;
    }
    // We only want to create a span list if we sampled the transaction
    // If sampled == false, we will discard the span anyway, so we can save memory by not storing child spans
    if (transaction.sampled) {
        var experimentsOptions = (client && client.getOptions()._experiments) || {};
        transaction.initSpanRecorder(experimentsOptions.maxSpans);
    }
    return transaction;
}
/**
 * {@see Hub.startTransaction}
 */
function startTransaction(context) {
    var transaction = new Transaction(context, this);
    return sample(this, transaction);
}
/**
 * Create new idle transaction.
 */
export function startIdleTransaction(hub, context, idleTimeout, onScope) {
    var transaction = new IdleTransaction(context, hub, idleTimeout, onScope);
    return sample(hub, transaction);
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */
export function addExtensionMethods() {
    var carrier = getMainCarrier();
    if (carrier.__SENTRY__) {
        carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
        if (!carrier.__SENTRY__.extensions.startTransaction) {
            carrier.__SENTRY__.extensions.startTransaction = startTransaction;
        }
        if (!carrier.__SENTRY__.extensions.traceHeaders) {
            carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
        }
    }
}
//# sourceMappingURL=hubextensions.js.map